import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { BrandedLoadingState } from '@/components/common';
import { buildLoginRoute } from '@/config/routes';
import { useAuth } from '@/features/auth/context';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, isAuthenticated } = useAuth();
  const location = useLocation();

  if (status === 'initializing') return <BrandedLoadingState />;
  if (!isAuthenticated) {
    const intended = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildLoginRoute({ redirect: intended })} replace />;
  }
  return children;
}
